import './FormField.scss';

export default function FormField({
    label,
    type = 'text',
    value,
    onChange,
    placeholder,
    autoComplete,
    rightElement,
    error,
    hint,
    maxLength,
    inputMode,
    autoCapitalize,
    spellCheck,
}) {
    const wrapClass = [
        'ui-form-field__input-wrap',
        error && 'ui-form-field__input-wrap--error',
        rightElement && 'ui-form-field__input-wrap--with-action',
    ].filter(Boolean).join(' ');

    return (
        <label className="ui-form-field">
            {label && <span className="ui-form-field__label">{label}</span>}
            <div className={wrapClass}>
                <input
                    className="ui-form-field__input"
                    type={type}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                    maxLength={maxLength}
                    inputMode={inputMode}
                    autoCapitalize={autoCapitalize}
                    spellCheck={spellCheck}
                />
                {rightElement && (
                    <div className="ui-form-field__action">{rightElement}</div>
                )}
            </div>
            {hint && !error && <span className="ui-form-field__hint">{hint}</span>}
            {error && <span className="ui-form-field__error">{error}</span>}
        </label>
    );
}
